<div class="mb-5 flex flex-col gap-5 py-6">
  @if (heading || subheading) {
    <div class="flex flex-col gap-2 px-5">
      @if (heading) {
        <h2 class="font-accent text-2xl font-bold text-neutral-800">
          {{ heading | translate }}
        </h2>
      }
      @if (subheading) {
        <div class="font-base text-sm text-neutral-600 lg:text-base">
          {{ subheading }}
        </div>
      }
    </div>
  }

  @if (
    (displayPoints && pointsBalance && pointsBalance > 0) ||
    (displayCredits && creditBalance && creditBalance > 0)
  ) {
    <div class="flex flex-row items-center px-5 font-base text-sm text-neutral-600 lg:text-base">
      <i class="icon icon-coins mt-0.5 pr-1.5"></i>
      @if (displayPoints && pointsBalance && pointsBalance > 0) {
        <span
          [translate]="'como.amount-of-points'"
          [translateParams]="{ points: pointsBalance / 100 }"
        ></span>
      }
      @if (
        displayPoints &&
        pointsBalance &&
        pointsBalance > 0 &&
        displayCredits &&
        creditBalance &&
        creditBalance > 0
      ) {
        <span class="px-1">—</span>
      }
      @if (displayCredits && creditBalance && creditBalance > 0) {
        <span>
          {{ 'como.credits-label' | translate }}
          <app-price-atom
            [amount]="creditBalance"
            [format]="true"
            [bold]="false"
            size="SM"
          ></app-price-atom>
        </span>
      }
    </div>
  }

  @if (!assets || assets.length === 0) {
    <div class="px-5 font-base text-sm text-neutral-600 lg:text-base">
      {{ 'como.no-assets' | translate }}
    </div>
  }
  <div
    #scrollContainer
    class="w-full overflow-x-auto scrollbar-hide"
    (scroll)="onAssetsScroll()"
  >
    @if (assets.length > 0) {
      <ul
        #assetsRow
        class="flex pl-5 pr-2"
      >
        @if (displayRedeemableGifts) {
          @for (asset of redeemableAssets; track asset) {
            <li class="mr-3 w-40 min-w-40 flex-shrink-0 flex-grow-0">
              <app-como-asset-item-atom
                [asset]="asset"
                [displayAddButton]="displayAddButton"
                [isAssetInCart]="!!(isAssetInCart$(asset) | async)"
                (assetAdd)="onAssetAdd.emit(asset)"
                (assetRemove)="onAssetRemove.emit(asset)"
              ></app-como-asset-item-atom>
            </li>
          }
        }
        @if (displayNotRedeemableGifts) {
          @for (asset of noRedeemableAssets; track asset) {
            <li class="mr-3 w-40 min-w-40 flex-shrink-0 flex-grow-0">
              <app-como-asset-item-atom
                [asset]="asset"
                [displayAddButton]="displayAddButton"
                [isAssetInCart]="!!(isAssetInCart$(asset) | async)"
                (assetAdd)="onAssetAdd.emit(asset)"
                (assetRemove)="onAssetRemove.emit(asset)"
              ></app-como-asset-item-atom>
            </li>
          }
        }
        @if (displayRedeemablePointShop) {
          @for (asset of redeemablePointShops; track asset) {
            <li class="mr-3 w-40 min-w-40 flex-shrink-0 flex-grow-0">
              <app-como-asset-item-atom
                [asset]="asset"
                [displayAddButton]="displayAddButton"
                [isAssetInCart]="!!(isAssetInCart$(asset) | async)"
                (assetAdd)="onAssetAdd.emit(asset)"
                (assetRemove)="onAssetRemove.emit(asset)"
              ></app-como-asset-item-atom>
            </li>
          }
        }
        @if (displayNotRedeemablePointShop) {
          @for (asset of noRedeemablePointShops; track asset) {
            <li class="mr-3 w-40 min-w-40 flex-shrink-0 flex-grow-0">
              <app-como-asset-item-atom
                [asset]="asset"
                [displayAddButton]="displayAddButton"
                [isAssetInCart]="!!(isAssetInCart$(asset) | async)"
                (assetAdd)="onAssetAdd.emit(asset)"
                (assetRemove)="onAssetRemove.emit(asset)"
              ></app-como-asset-item-atom>
            </li>
          }
        }
        @if (displayNotUsablePointShop) {
          @for (asset of pointShops; track asset) {
            <li class="mr-3 w-40 min-w-40 flex-shrink-0 flex-grow-0">
              <app-como-asset-item-atom
                [asset]="asset"
                [displayAddButton]="displayAddButton"
                (assetAdd)="onAssetAdd.emit(asset)"
                (assetRemove)="onAssetRemove.emit(asset)"
              ></app-como-asset-item-atom>
            </li>
          }
        }
        <li class="w-4 flex-shrink-0"></li>
      </ul>
    }
  </div>
  @if (showDesktopScrollbar) {
    <div
      class="mx-5 mt-4 h-1.5 cursor-pointer rounded-full bg-neutral-300"
      (pointerdown)="onScrollbarPointerDown($event)"
      (pointermove)="onScrollbarPointerMove($event)"
      (pointerup)="onScrollbarPointerUp()"
      (pointercancel)="onScrollbarPointerUp()"
    >
      <div
        class="pointer-events-none h-full rounded-full bg-neutral-600"
        [style.width.%]="thumbWidthPercent"
        [style.marginLeft.%]="thumbLeftPercent"
      ></div>
    </div>
  }
</div>
